import React, {useState} from "react";
import {Helmet} from "react-helmet-async";
import EasSystem from "./EasSystem";
import EasEnrollModal from "../components/eas/EasEnrollModal";

/**
 * Mounted at "/system" in the router. The full $2,997 sales surface — kept on
 * its own URL so the existing $997 webinar funnel promo stays a real promotion.
 */
export default function SystemPage(): JSX.Element {
    const [modalOpen, setModalOpen] = useState(false);

    return (
        <>
            <Helmet>
                <title>Effective Action System — full program · $2,997</title>
                <meta
                    name="description"
                    content="The full six-week Effective Action System for teenagers. 40+ lessons, weekly office hours, 1:1 onboarding, 30-day guarantee."
                />
                <link rel="canonical" href="https://effectiveactionsystem.com/system"/>
                <meta property="og:title" content="Effective Action System — full program"/>
                <meta property="og:description" content="$2,997 · lifetime access · 30-day guarantee."/>
                <meta property="og:url" content="https://effectiveactionsystem.com/system"/>
                <meta property="og:type" content="product"/>
            </Helmet>
            <EasSystem onEnroll={() => setModalOpen(true)}/>
            <EasEnrollModal open={modalOpen} onClose={() => setModalOpen(false)}/>
        </>
    );
}
